<template>
  <div class="container">
    <div class="main">
      <h1>万顺代驾司机合同协议</h1>
      <p>甲方：代驾服务使用方</p>
      <p>乙方：代驾服务提供方</p>
      <p>
        甲、乙双方均为深圳万顺叫车云信息技术有限公司平台用户，通过平台使用或提供代驾服务，均应遵守本协议内容。
      </p>
      <h2>一、 甲方权利义务</h2>
      <ul>
        <li class="blot">
          1.1确定代驾车辆具备上路行驶手续齐全、车辆行驶证及交强险未过期、车辆正常年检、车况正常（非改装车及部件，非军用车）保险有效等适宜代驾的条件，如因甲方隐瞒以上事实带来的纠纷或者损害，由甲方承担。
        </li>
        <li>
          1.2有权要求乙方按指定路线行驶，但不得要求乙方超速、逆行等违章驾驶。
        </li>
        <li>
          1.3不得利用代驾从事违法犯罪行为，不得运载违禁、易燃易爆等危险物品。
        </li>
        <li>1.4妥善保管车内及随身财物，如代驾过程中出现遗失，应立即报警。</li>
        <li>1.5按照平台公示标准和本协议约定支付代驾服务费及其他费用。</li>
        <li>1.6有权对乙方的代驾服务在平台上进行客观评价。</li>
      </ul>

      <h2>二、 乙方权利义务</h2>
      <ul>
        <li>
          2.1身体健康，无传染性和器质性疾病，无眩晕症和美的尔氏综合征，无震颤性等影响司机提供代驾服务的疾病，无疲惫、饮酒等。
        </li>
        <li>
          2.2年龄:25到57周岁，身体健康，本人拥有C1及以上驾照，驾龄3年以上。无明显纹身、疤痕、胎记，着装整洁，无体味。
        </li>
        <li>
          2.3无交通肇事犯罪、危险驾驶犯罪记录，无吸毒记录，无饮酒后驾驶记录。
        </li>
        <li>
          2.4代驾时服饰整洁，举止文明，并穿着平台标识服装、胸牌，便于识别。
        </li>
        <li>2.5接单后不得擅自将甲方车辆交由他人驾驶。</li>
        <li>
          2.6遵守交规，爱惜车辆，避免原地打轮、换挡不畅、压线等不良驾驶行为。
        </li>
        <li>2.7结束代驾服务后检查并关闭所有车门、车窗及用电设备。</li>
        <li>
          2.8按照平台公示标准和本协议约定向甲方展示订单记录的里程和费用，收取代驾服务费及其他费用。
        </li>
        <li>
          2.9如遇交通事故，应立即报警，听从交警部门处理，不得逃离现场，并积极配合保险公司进行事故处理。
        </li>
      </ul>

      <h2>三、代驾服务费用</h2>
      <ul>
        <li>
          3.1
          双方同意以平台订单记录的时间、里程及公示的费用标准为结算依据，并由甲方在车辆到达目的地后，甲方将代驾费用在平台支付。
        </li>
        <li>
          3.2若甲方对代驾服务费存有异议，仍应先行付款，可在24小时内向平台提出异议并提供相关证据，经核实确定计费错误，则由平台退还多收取的费用。
        </li>
        <li>
          3.3
          在代驾服务过程中产生的高速路收费，停车费等其他临时费用均由甲方承担，如因特殊原因乙方先行垫付了上述款项，则平台应及时返还乙方。
        </li>
      </ul>

      <h2>四、交通事故处理</h2>
      <ul>
        <li>
          4.1代驾过程中发生交通事故，双方应当根据交警部门的事故认定确定责任。因车辆本身安全性能问题或者甲方不当阻碍、扰乱车辆安全行驶等发生事故由甲方承担责任。经认定属于乙方过错的，由乙方承担相应责任；非乙方过错的乙方不承担责任；属第三方过错的，由甲方直接要求该第三方承担责任。
        </li>
        <li class="blot">
          4.2任何一方原因造成交通事故，根据交警部门的交通事故责任认定，代驾服务提供方存在过错的，应建议使用代驾平台投保的代驾责任险对相关人身、财产损失进行赔偿，不足部分，由代驾服务提供方在交警部门认定的责任范围内承担补充责任；非代驾服务提供方过错的，由代驾服务使用方直接向相应责任方进行追偿。代驾平台对于车辆贬值及其他间接损失不负责赔偿。根据公平原则，为避免将代驾平台置于不可承担的风险之中，代驾服务使用方不得授权保险公司向代驾平台进行追偿或转让追偿权利。
        </li>
        <li>
          4.3交通事故发生后，为救助伤者或者减少损失，乙方先行向甲方或者第三方赔偿或垫付款项的，或者乙方在事故中受伤而自身遭受损失的，甲方应积极配合乙方进行相关追偿。
        </li>
        <li>
          4.4甲、乙任何一方因违反交通法规或其他法律规定而受到国家有关部门处罚或处理的，由责任方自行承担。
        </li>
        <li>4.5甲方明确除外责任包括：</li>
        <li>
          1）暴雨、冰雹等自然灾害及其他无法预见、不能避免的不可抗力至甲方或甲方车辆受损的。
        </li>
        <li>2）非真实性、服务订单结束后报案的。</li>
        <li>
          3）甲方车辆行驶证过期或未办理、交强险过期或未投保、牌照或临时牌照过期或不具备牌照、机动车未进行年检的。
        </li>
        <li>4）甲方出现的物品等车辆之外的财务丢失或损坏。</li>
        <li>
          5）包括但不限于路边飞石等类意外或第三方非责任等非代驾服务提供方责任事故。
        </li>
        <li>6）甲方车辆的玻璃单独破碎，轮胎轮毂单独损坏。</li>
        <li>7）甲方车辆自燃。</li>
        <li>8）甲方车辆为右舵车、营运车辆、军车车辆、行政车辆、特种车辆。</li>
        <li>9）甲方车辆为改装车辆及含有改装部件车辆。</li>
        <li>10）乙方委托的保险公司确定的维修金额之外的费用。</li>
        <li>
          11）甲方在乙方委托的保险公司确定维修项目及金额前擅自修车，致使乙方委托的保险公司无法确定损失情况，最终导致无法赔付的。
        </li>
        <li>如出现以上免责情况，赔偿责任应由甲方自行承担。</li>
        <li>4.6对于出现争议的交通事故乙方有权保留对此事故处理的意见。</li>
      </ul>

      <h2>五、违约责任</h2>
      <ul>
        <li>
          5.1甲方要求或迫使乙方中途停止代驾服务的（包括但不限于对代驾服务费有异议、对乙方服务不满、醉酒等原因），甲方仍须据实向乙方支付代驾服务费。乙方停止代驾后的全部后果由甲方承担。
        </li>
        <li>
          5.2乙方对行驶路线选择明显错误，或者故意绕行增加代驾服务费用的，应向甲方退回多收取部分的费用。
        </li>
      </ul>
      <h2>六、特别约定</h2>
      <ul>
        <li class="blot">
          各方确认并知悉，平台仅为向甲乙双方提供代驾信息服务、促成双方签订本协议的中间人，并不实际提供也不代理任何一方提供本协议项下代驾服务，平台有权对代驾服务进行质量监控，但不对代驾服务过程中产生的纠纷或争议承担责任，也不对甲乙双方代驾服务过程中或准备服务过程中、结束服务后遭受的损失承担责任。
        </li>
      </ul>
      <h2>七、协议效力</h2>
      <ul>
        <li>
          7.1<strong>甲方通过平台叫单，乙方接单后即视为双方自愿达成了本协议。</strong>本协议附件属于协议不可分割的组成部分，与本协议具有同等法律效力。
        </li>
      </ul>
      <h2>八、争议解决</h2>
      <ul>
        <li class="blot">
          本协议履行过程中发生的争议，各方应友好协商解决，协商未成的，各方一致同意将争议提交<span>深圳市宝安区</span>人民法院诉讼解决。
        </li>
      </ul>

      <div class="box">
        <div class="item">
          <p>甲方：</p>
          <p>签字盖章：</p>
          <p>日期： 年 月 日</p>
        </div>
        <div class="item">
          <p>乙方：</p>
          <p>签字盖章：</p>
          <p>日期： 年 月 日</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="less">
.container {
  padding: 20px;
  h1 {
    font-size: 22px;
    font-weight: 900;
    text-align: center;
    margin-bottom: 10px;
  }
  p {
    font-size: 14px;
    line-height: 26px;
  }
  h2 {
    font-size: 18px;
    font-weight: 900;
    line-height: 36px;
  }
  ul {
    margin-bottom: 10px;
    li {
      font-size: 14px;
      line-height: 26px;
      span{
        color: red;
      }
    }
  }
  .blot{
    font-weight: 900;
  }
  .box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 20px;
    .item{
      width: 50%;
    }
  }
}
</style>

